import { render, staticRenderFns } from "./BotonModulos.vue?vue&type=template&id=651f245d"
import script from "./BotonModulos.vue?vue&type=script&lang=js"
export * from "./BotonModulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports